import { TFunction } from 'i18next';

export const NAV_HEIGHT = '8rem';
export const NAV_SMALL_HEIGHT = '5rem';

export const FOOTER_WIDTH = '125rem';
export const EVENT_SECTION_WIDTH = '154rem';
export const BLOG_ITEM_WIDTH = '45rem';
export const SPEAKER_PAGE_WIDTH = '113rem';
export const EVENT_HOME_WIDTH = '140rem';
export const CONTACT_FORM_WIDTH = '84rem';
export const HEADER_HEIGHT = '6rem';

export const EMAIL = {
  SUPPORT: 'support@we-conect.com',
  LUFTHANSA: 'lufthansa.mobility@dhl.de',
  OPERATIONS: 'eike.nenninger@we-conect.com',
};
export const THEME = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
} as const;

export const THEME_TYPE = ['LIGHT', 'DARK'] as const;

export const MODE = {
  OVERVIEW: 'overview',
  PORTFOLIO: 'portfolio',
  EVENT: 'event',
  WEBINAR: 'webinar',
} as const;

export const MODE_TYPE = [
  MODE.OVERVIEW,
  MODE.PORTFOLIO,
  MODE.EVENT,
  MODE.WEBINAR,
] as const;

export const LANGUAGE = {
  ENGLISH: 'en',
  GERMAN: 'de',
} as const;

export const LANGUAGE_TYPE = [LANGUAGE.ENGLISH, LANGUAGE.GERMAN] as const;

export const LANGUAGE_INTL = {
  en: 'en-GB',
  de: 'de-DE',
} as const;

export const LANGUAGE_INTL_TYPE = ['en-GB', 'de-DE'] as const;

export const SPONSOR_EMAIL = 'partnering@we-conect.com';
export const SPEAKER_EMAIL = 'speaking@we-conect.com';
export const ATTENDEE_EMAIL = 'bookings@we-conect.com';
export const MEDIA_PARTNERSHIP_EMAIL = 'marketing@we-conect.com';
export const GENERAL_ENQUIRIES = 'info@we-conect.com';
export const OPERATIONS_EMAIL = 'operations@we-conect.com';

export const LOCAL_STORAGE_TYPE = {
  LANGUAGE: 'language',
};

export const LANGUAGE_SWITCHER_MODE = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export const LANGUAGE_SWITCHER_MODE_TYPE = [
  LANGUAGE_SWITCHER_MODE.LIGHT,
  LANGUAGE_SWITCHER_MODE.DARK,
] as const;

export const SCROLL_DOWN_MODE = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export const SCROLL_DOWN_MODE_TYPE = [
  SCROLL_DOWN_MODE.LIGHT,
  SCROLL_DOWN_MODE.DARK,
] as const;

export const PARTNER = {
  COMPETENCE: 'competence',
  BUSINESS: 'business',
  EVENT_LEAD: 'event-lead',
  PRIMARY: 'primary',
  MEDIA: 'media',
} as const;

export const PARTNER_TYPE = [
  PARTNER.COMPETENCE,
  PARTNER.BUSINESS,
  PARTNER.EVENT_LEAD,
  PARTNER.PRIMARY,
  PARTNER.MEDIA,
] as const;

export const eventNetworkingItems = [
  {
    icon: 'attendee',
    title: 'event-networking-modal-text-1',
  },
  {
    icon: 'attendee',
    title: 'event-networking-modal-text-3',
  },

  {
    icon: 'speaker',
    title: 'event-networking-modal-text-5',
  },
  {
    icon: 'attendees',
    title: 'event-networking-modal-text-7',
  },
  {
    icon: 'meeting',
    title: 'event-networking-modal-text-9',
  },

  {
    icon: 'attendee',
    title: 'event-networking-modal-text-11',
  },
  {
    icon: 'attendee',
    title: 'event-networking-modal-text-13',
  },
  {
    icon: 'speaker',
    title: 'event-networking-modal-text-15',
  },
  {
    icon: 'attendees',
    title: 'event-networking-modal-text-17',
  },
  {
    icon: 'attendee',
    title: 'event-networking-modal-text-19',
  },
];

export interface TxtSection {
  id: string;
  title: string;
  text: string;
  img: string;
}

export const MULTI_TOUCHPOINT_ITEMS = (
  t: TFunction<'translation', undefined>,
  eventName: string
): TxtSection[] => [
  {
    id: 'casestudy',
    title: t('mtpn-casestudy-title'),
    text: t('mtpn-casestudy-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/casestudy.jpg',
  },
  {
    id: 'paneldiscussion',
    title: t('mtpn-panel-title'),
    text: t('mtpn-panel-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/panel_discussion.jpg',
  },
  {
    id: '4-start-expo-floor-experience',
    title: t('mtpn-4-start-expo-floor-experience-title'),
    text: t('mtpn-4-start-expo-floor-experience-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/expo_floor.jpg',
  },
  {
    id: 'tech-takes-tech-demos',
    title: t('mtpn-tech-takes-tech-demos-title'),
    text: t('mtpn-tech-takes-tech-demos-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/techtake.jpg',
  },
  {
    id: 'start-up-pitches',
    title: t('mtpn-start-up-pitches-title'),
    text: t('mtpn-start-up-pitches-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/startup.jpg',
  },
  {
    id: 'one-2-one-meetings',
    title: t('mtpn-one-2-one-meetings-title'),
    text: t('mtpn-one-2-one-meetings-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/100minutes.jpg',
  },
  {
    id: 'smart-business-networking-with-ai-powered-marketing',
    title: t('mtpn-smart-business-networking-with-ai-powered-marketing-title'),
    text: t('mtpn-smart-business-networking-with-ai-powered-marketing-text', {
      eventName,
    }),
    img: 'https://media.we-conect.com/images/pdf/agenda/smart_networking.jpg',
  },
  {
    id: 'networkingdinner',
    title: t('mtpn-dinner-title'),
    text: t('mtpn-dinner-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/networking_dinner.jpg',
  },
  {
    id: 'icebreaker',
    title: t('mtpn-icebreaker-title'),
    text: t('mtpn-icebreaker-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/icebreaker.jpg',
  },
  {
    id: 'challengeyourpeers',
    title: t('mtpn-cyp-title'),
    text: t('mtpn-cyp-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/challengeyourpeers.jpg',
  },
  {
    id: 'worldcafe',
    title: t('mtpn-worldcafe-title'),
    text: t('mtpn-worldcafe-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/worldcafe.jpg',
  },
  {
    id: 'sayhello',
    title: t('mtpn-sayhello-title'),
    text: t('mtpn-sayhello-text', { eventName }),
    img: 'https://media.we-conect.com/images/pdf/agenda/say_hello_session.jpg',
  },
];

export const mappableCompanyRouteKeys = [
  'career-url',
  'terms-and-conditions-url',
  'our-awards-url',
  'about-us-url',
  'social-responsibility-url',
  'contact-url',
  'newsletter-unsubscribe-url',
  'imprint-url',
  'our-team-url',
  'our-product-portfolio-url',
  'multitouchpoint-networking-url',
  'declaration-of-consent-url',
  'privacy-your-data-url',
  'privacy-take-control-url',
];
